






















































import { Component, Vue, Prop } from 'vue-property-decorator';
import router from '../../router';
import { vxm } from '../../store.vuex';
import RegistrationCard from './Card.vue';
import Container from './Container.vue';

@Component({
  name: 'AppRetrievedEmailVerification',
  components: {
    RegistrationCard,
    Container,
  },
})
export default class AppRetrievedEmailVerification extends Vue {
  private retrievedEmail: string = '';
  $wlToastr: any;

  redirectLogin() {
    console.log('Redirecting to login');
    router.push({ name: 'AppSignup' });
  }

  redirectValidate() {
    const vm = this;
    vxm.users.UserParams.populateSignupPage = true;
    const respPromise: any = vxm.users.validateRetrievedEmail(
      this.retrievedEmail,
    );
    Promise.all([respPromise]).then((values) => {
      if (values[0].status === 'success') {
        vxm.users.setDuplicateCheckRequired(false);
        vxm.users.setPopulateSignupPage(true);
        vxm.users.setRetrievedEmail(this.retrievedEmail);
        if (vxm.users.UserParams.isSocialMediaSignup) {
          router.push({ name: 'AppRetrievedEmailSignupPreference' });
        } else {
          router.push({ name: 'AppSignup' });
        }
      } else {
        const error = values[0].error;
        vm.$wlToastr('error', error, 'Verification');
      }
    });
  }
}
